import { cva, VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = {
  variant: {
    default: null,
    highlighted: null,
    trigger:
      'border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3',
    home: null,
    away: null,
    score: null,
    attempt: null,
    stopped: null,
    missed: null,
    action: null,
  },
  disabled: {
    false: null,
    true: null,
  },
  selected: {
    false: null,
    true: null,
  },
} as const

export const buttonCva = cva('', {
  variants: buttonVariants,
  compoundVariants: [
    // default
    {
      variant: 'default',
      disabled: false,
      class:
        'bg-neutral-light-9 border-neutral-light-0 hover:bg-neutral-light-4 active:bg-neutral-light-7',
    },
    {
      variant: 'default',
      disabled: true,
      class: 'border-neutral-light-0/30 bg-neutral-light-9/70',
    },
    {
      variant: 'default',
      selected: true,
      class: 'enabled:bg-neutral-light-0',
    },
    // highlighted
    {
      variant: 'highlighted',
      disabled: false,
      class:
        'bg-neutral-light-7 border-neutral-light-0 hover:bg-neutral-light-3 active:bg-neutral-light-4',
    },
    {
      variant: 'highlighted',
      disabled: true,
      class: 'border-neutral-light-3',
    },
    {
      variant: 'highlighted',
      selected: true,
      class: 'enabled:bg-neutral-light-1',
    },
    // home
    {
      variant: 'home',
      disabled: false,
      class:
        'bg-current-team-home-10 border-current-team-home-5 hover:bg-current-team-home-8 active:bg-current-team-home-5',
    },
    {
      variant: 'home',
      disabled: true,
      class: 'bg-current-team-home-10/30 border-current-team-home-5/70',
    },
    // away
    {
      variant: 'away',
      disabled: false,
      class:
        'bg-current-team-away-10 border-current-team-away-5 hover:bg-current-team-away-8 active:bg-current-team-away-5',
    },
    {
      variant: 'away',
      disabled: true,
      class: 'bg-current-team-away-10/30 border-current-team-away-5/70',
    },
    // score
    {
      variant: 'score',
      disabled: false,
      class:
        'border-success-5 bg-success-10 hover:bg-success-8 active:bg-success-3',
    },
    {
      variant: 'score',
      disabled: true,
      class: 'border-success-5/30 bg-success-10/70',
    },
    {
      variant: 'score',
      selected: true,
      class: 'enabled:bg-success-3 enabled:text-neutral-light-10',
    },
    // attempt
    {
      variant: 'attempt',
      disabled: false,
      class:
        'border-success-5 bg-success-9 hover:bg-success-8 active:bg-success-4 active:text-neutral-light-10',
    },
    {
      variant: 'attempt',
      disabled: true,
      class: 'border-success-5/30 bg-success-9/70',
    },
    {
      variant: 'attempt',
      selected: true,
      class: 'enabled:bg-success-4 enabled:text-neutral-light-10',
    },
    // stopped
    {
      variant: 'stopped',
      disabled: false,
      class:
        'border-team-home-5 bg-team-home-10 hover:bg-team-home-8 active:bg-team-home-3 active:text-neutral-light-10',
    },
    {
      variant: 'stopped',
      disabled: true,
      class: 'border-team-home-5/30 bg-team-home-10/70',
    },
    {
      variant: 'stopped',
      selected: true,
      class: 'enabled:bg-team-home-3 enabled:text-neutral-light-10',
    },
    // missed
    {
      variant: 'missed',
      disabled: false,
      class:
        'border-error-5 bg-error-10 hover:bg-error-8 active:bg-error-3 active:text-neutral-light-10',
    },
    {
      variant: 'missed',
      disabled: true,
      class: 'border-error-9/30 bg-error-10/70',
    },
    {
      variant: 'missed',
      selected: true,
      class: 'enabled:bg-error-3 enabled:text-neutral-light-10',
    },
    // action
    {
      variant: 'action',
      disabled: false,
      class:
        'bg-neutral-light-5 border-neutral-light-0 hover:bg-neutral-light-3 active:bg-neutral-light-0',
    },
  ],
})
export type ButtonProps = VariantProps<typeof buttonCva>
